/* Updated GameweekNativeSlider with LEFT scroll on first render */

import React, { Component } from "react";
import { Utils, _, Trans } from "Helpers";
import { Tabs, Tab } from "react-tabs-scrollable";
import { ReduxHOC } from "HOC";

class GameweekNativeSlider extends Component {
  constructor(props) {
    super(props);

    const visibleWeeks = (props.scoring_weeks || []).filter(
      (item) => item.week <= props.next_week || props.is_fixture
    );

    const idx = _.findIndex(visibleWeeks, (o) => o.week === props.SelectedWeek);

    this.state = {
      activeTab: idx >= 0 ? idx : 0,
      selected_league: Utils.getMultiLeg(),
      init: false,
    };

    this.scrollContainerRef = React.createRef();
    this.tabRefs = [];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.init) {
      const visibleWeeks = (nextProps.scoring_weeks || []).filter(
        (item) => item.week <= nextProps.next_week || nextProps.is_fixture
      );

      const idx = _.findIndex(visibleWeeks, (o) => o.week === nextProps.SelectedWeek);

      this.setState({
        activeTab: idx >= 0 ? idx : 0,
        init: true,
      });
    }
  }

  clickHandler = (e, index) => {
    const { SelectWeekHandle, scoring_weeks } = this.props;
    this.setState({ activeTab: index }, () => {
      SelectWeekHandle(scoring_weeks[index]);
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.activeTab !== this.state.activeTab ||
      prevProps.scoring_weeks !== this.props.scoring_weeks ||
      prevProps.SelectedWeek !== this.props.SelectedWeek
    ) {
      const visibleWeeks = (this.props.scoring_weeks || []).filter(
        (item) => item.week <= this.props.next_week || this.props.is_fixture
      );

      let targetIndex = this.state.activeTab;

      if (!visibleWeeks[targetIndex]) {
        const idxByWeek = visibleWeeks.findIndex(
          (w) => w.week === this.state.activeTab || w.week === this.props.SelectedWeek
        );
        if (idxByWeek >= 0) targetIndex = idxByWeek;
      }

      targetIndex = Math.max(0, Math.min(targetIndex, visibleWeeks.length - 1));

      // Scroll LEFT instead of center
      this.scrollToLeft(targetIndex);
      return;
    }
  }

  scrollToLeft = (index) => {
    try {
      const container = this.scrollContainerRef.current?.querySelector(
        ".rts__scrollWrapper"
      );
      const tabEl = this.tabRefs[index];

      if (container && tabEl) {
        container.scrollTo({ left: tabEl.offsetLeft, behavior: "smooth" });
      }
    } catch (err) {
      console.log("Scroll error", err);
    }
  };

  render() {
    const {
      scoring_weeks,
      SelectedWeek,
      active_week,
      next_week,
      last_week,
      joined_week,
      is_fixture,
      is_temp,
      i18n,
      selectedWk,
      selectedLeague,
    } = this.props;

    const { selected_league, activeTab } = this.state;

    return (
      <Tabs
        ref={this.scrollContainerRef}
        isRTL={i18n.language === "ar"}
        activeTab={activeTab}
        onTabClick={this.clickHandler}
        tabsClassName="gameweek-inner"
        tabsContainerClassName="gameweek-weekslider native-scroll"
        rightBtnIcon={<i className="icon-next" />}
        leftBtnIcon={<i className="icon-previous" />}
      >
        {_.map(scoring_weeks, (item, idx) => {
          if (!(item.week <= next_week) && !is_fixture) return null;

          return (
            <Tab
              key={idx}
              ref={(el) => (this.tabRefs[idx] = el)}
              className={`week-item${
                Number(item.week) === Number(SelectedWeek) || Number(item.week) === Number(selectedWk) ? " active" : ""
              } ${item.is_hide_date === "1" ? "dis-click" : ""}`}
            >
              <WeekCard
                {...{
                  item,
                  selected_league,
                  is_temp,
                  active_week,
                  joined_week,
                  next_week,
                  is_fixture,
                  last_week,
                  selectedLeague,
                }}
              />
            </Tab>
          );
        })}
      </Tabs>
    );
  }
}

GameweekNativeSlider.defaultProps = {
  scoring_weeks: [],
  SelectedWeek: null,
  selectedWk: null,
  SelectWeekHandle: () => {},
  active_week: null,
  next_week: null,
  last_week: null,
  joined_week: null,
  is_fixture: false,
  is_temp: false,
};


export default ReduxHOC(GameweekNativeSlider);

const WeekCard = ({
  item,
  selected_league,
  is_temp,
  active_week,
  joined_week,
  next_week,
  last_week,
  is_fixture,
  selectedLeague,
}) => {
  return (
    <>
      {is_temp ? (
        <div className="week-label">
          <Trans>FIFA World Cup 2022</Trans>
        </div>
      ) : (
        <div className="week-label">
          {selectedLeague
            ? selectedLeague.week_label[item.week] || item.week
            : selected_league.week_label[item.week] || item.week}
        </div>
      )}

      {!is_fixture && (
        <div className="week-status">
          {item.week === active_week && (active_week < next_week || active_week === last_week) && (
            <b></b>
          )}

          {item.week === next_week &&
            (active_week < next_week ||
              (joined_week === next_week && next_week !== active_week) ||
              active_week !== last_week) && (
              <span>
                <Trans>Upcoming</Trans>
              </span>
            )}

          {!(
            item.week === next_week &&
            (active_week < next_week ||
              (joined_week === next_week && next_week !== active_week) ||
              active_week !== last_week)
          ) && (
            <span>
              {item.total_score} <Trans>Pts</Trans>
            </span>
          )}
        </div>
      )}
    </>
  );
};